import TermsLink from './TermsLink';

export default TermsLink;
